import { MenuItem } from "../../Components/Views/UI/MenuItem";
import { ViewItem } from "../../Components/Views/ViewItem";
import { MenuItems } from "../../Controllers/Menu/MenuItems";

class MenuItemsView extends ViewItem {

    get controller(): MenuItems {
        return this.props.controller
    }

    render() {
        const { menuItems } = this.controller
        return <div className="menu-items">
            {menuItems && menuItems.map((menu, i)=><MenuItem key={`${menu.name}_${i}`} ref={menu.setRef} component={menu} selected={menu.selected}/>)}
        </div>
    }
}

export { MenuItemsView }